import React, { Component } from 'react'
import classnames from 'classnames'
import styles from './index.module.less'
import URL from '../../lib/URL'
import Utils from '../../lib/utils'

function getCurrentPath (navItemList) {
  let localPath = __isBrowser__ ? location.pathname : ''
  if (localPath === '/') {
    return -1
  }

  let _tagIndex = -1
  navItemList.map((item, index) => {
    const _link = item.videoId ? item.videoId : item.link
    const urlObj = new URL(_link)
    _tagIndex = urlObj.pathname && urlObj.pathname === localPath ? index : _tagIndex
    return _tagIndex
  })
  return _tagIndex
}
// 标题渲染
function ChannelTitle (mainTitleLinks, tagIndex) {
  const _className = tagIndex === -1 ? classnames(styles.chanel_title, styles.current_path) : styles.chanel_title
  if (mainTitleLinks && mainTitleLinks.length > 0) {
    return (
      <a {...Utils.getItemSpmData(mainTitleLinks[0], true)}
        {...Utils.getATagProps(mainTitleLinks[0])}>
        <h2 className={_className}>
          {mainTitleLinks[0].title}
        </h2>
      </a>
    )
  } else {
    return ''
  }
}

function RigthBanner (component, index) {
  if (!component || !component.itemList) {
    return ''
  }

  return (
    <div key={index}
      className={styles.right_links}
      {...Utils.getComponentSpmData(component)}>
      {
        component.itemList.map((item, index) => {
          return (
            <a {...Utils.getItemSpmData(item)}
              {...Utils.getATagProps(item)}
              key={index}> {item.title} <span>›</span>
            </a>)
        })
      }
    </div>)
}

function LeftList (component, index, tagIndex) {
  if (!component || !component.itemList) {
    return ''
  }

  return (
    <div key={index}
      className={styles.sub_links}
      {...Utils.getComponentSpmData(component)}>
      {
        component.itemList.map((item, index) => {
          const _className = tagIndex === index ? styles.current_path : ''
          if (index > 3) {
            return (
              <a
                {...Utils.getItemSpmData(item)}
                {...Utils.getATagProps(item)}
                key={index}
                className={`s-hide ${_className}`}>{item.title}</a>
            )
          } else if (index < 8) {
            return (
              <a
                className={_className}
                {...Utils.getItemSpmData(item)}
                {...Utils.getATagProps(item)}
                key={index}>{item.title}</a>
            )
          }
          return ''
        })}
    </div>
  )
}
export default class ChanelHeader extends Component {
  constructor (props) {
    super(props)
    this.state = {
      curTagIndex: -1
    }
  }

  componentDidMount () {
    const _curPathIndex = this.props.components.length > 0 ? getCurrentPath(this.props.components[0].itemList) : -1
    this.setState({ curTagIndex: _curPathIndex })
  }

  render () {
    return (
      <div className={styles.chanel_header}>
        { ChannelTitle(this.props.mainTitleLinks, this.state.curTagIndex) }
        {
          this.props.components.map((component, index) => {
            if (index > 2) {
              return
            }
            if (component.tag === 'WEB_SECONDARY_NAV') {
              return LeftList(component, index, this.state.curTagIndex)
            } else if (component.tag === 'WEB_SECONDARY_KEYWORD') {
              return RigthBanner(component, index)
            }
            return ''
          })}
      </div>
    )
  }
}
